var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_1650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08341 3.49967H13.4167V9.21634H14.5834V3.49967C14.5834 3.19026 14.4605 2.89351 14.2417 2.67472C14.0229 2.45592 13.7262 2.33301 13.4167 2.33301H4.08341C3.774 2.33301 3.47725 2.45592 3.25846 2.67472C3.03966 2.89351 2.91675 3.19026 2.91675 3.49967V17.4997C2.91675 17.8091 3.03966 18.1058 3.25846 18.3246C3.47725 18.5434 3.774 18.6663 4.08341 18.6663H13.4167C13.7262 18.6663 14.0229 18.5434 14.2417 18.3246C14.4605 18.1058 14.5834 17.8091 14.5834 17.4997H4.08341V3.49967Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4267 10.0797C16.3151 9.98415 16.1715 9.93422 16.0247 9.93989C15.8779 9.94556 15.7387 10.0064 15.6348 10.1103C15.5309 10.2142 15.47 10.3535 15.4643 10.5003C15.4587 10.6471 15.5086 10.7906 15.6042 10.9022L17.5758 12.8331H9.11751C8.9628 12.8331 8.81443 12.8945 8.70503 13.0039C8.59564 13.1133 8.53418 13.2617 8.53418 13.4164C8.53418 13.5711 8.59564 13.7195 8.70503 13.8289C8.81443 13.9383 8.9628 13.9997 9.11751 13.9997H17.5758L15.6042 16.0181C15.5431 16.0703 15.4935 16.1347 15.4585 16.2071C15.4235 16.2794 15.4038 16.3583 15.4007 16.4386C15.3976 16.5189 15.4111 16.5991 15.4405 16.6739C15.4698 16.7488 15.5143 16.8168 15.5711 16.8736C15.628 16.9304 15.696 16.9749 15.7708 17.0043C15.8457 17.0336 15.9258 17.0471 16.0061 17.044C16.0865 17.0409 16.1653 17.0212 16.2377 16.9862C16.31 16.9512 16.3744 16.9016 16.4267 16.8406L19.8333 13.4572L16.4267 10.0797Z",
    fill: "#CC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_1650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.c0b0ced6aaa04b5c4b4406f0c78cac9c.svg";
export { ForwardRef as ReactComponent };